// extracted by mini-css-extract-plugin
module.exports = {"wrap":"jl","heading":"kl","items":"ll","featureCss":"ml","disabled":"nl","imgCss":"ol"};